module.exports = __webpack_public_path__ + "static/media/fa-brands-400.65e3be4e.woff2";